import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="relative overflow-hidden">
      <div className="flex flex-col lg:flex-row min-h-[500px]">
        <div className="relative lg:w-1/2 min-h-[320px] lg:min-h-[500px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Stylish%20contemporary%20fashion%20flat%20lay%20with%20designer%20inspired%20sneakers%20premium%20hoodies%20and%20leather%20accessories%20on%20textured%20linen%20fabric%2C%20soft%20directional%20light%20from%20left%20side%20creating%20depth%2C%20modern%20European%20lifestyle%20editorial%2C%20warm%20sand%20and%20terracotta%20tones%20with%20charcoal%20accents%2C%20sophisticated%20and%20aspirational%2C%20no%20logos&width=900&height=600&seq=cta-left-img-02&orientation=landscape&nocache=true"
            alt="Fashion products"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute top-6 left-6">
            <span className="text-xs font-medium uppercase tracking-wider text-white/70 bg-black/30 px-3 py-1 rounded-full">
              VAI A KASPREADSHEET
            </span>
          </div>
          <div className="absolute bottom-8 left-8">
            <h3 className="text-3xl md:text-4xl font-heading font-bold text-white leading-tight">
              Scopri Tutti
              <br />
              i Prodotti
              <br />
              <span className="text-primary-300">Organizzati</span>
            </h3>
          </div>
        </div>

        <div className="lg:w-1/2 bg-background-50 flex flex-col items-center justify-center text-center px-6 py-14 lg:py-0">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 leading-tight">
            Scegli la tua
            <br />
            Categoria
          </h2>
          <p className="mt-4 text-foreground-600 text-sm max-w-sm leading-relaxed">
            Ogni categoria è collegata direttamente al nostro spreadsheet su Kaspreadsheet. 
            Trova prodotti verificati con foto QC, prezzi aggiornati e link diretti ai venditori.
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-4 mt-8">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="px-10 py-3.5 text-sm font-semibold rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              itaobuy sheet
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="px-10 py-3.5 text-sm font-semibold rounded-full bg-accent-500 text-background-50 hover:bg-accent-600 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              buy it now
              <i className="ri-external-link-line ml-2"></i>
            </a>
          </div>

          <p className="mt-8 text-xs text-foreground-400">
            Lista aggiornata — Ultimo aggiornamento: Luglio 2026
          </p>
        </div>
      </div>
    </section>
  );
}